var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditjarFaviconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 44,
    viewBox: "0 0 201 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 10.2035V6.08309C20.7033 6.09753 18.4221 7.97801 17.2477 10.2356H23.1082C23.1948 10.2356 23.2812 10.2368 23.3672 10.2391C23.4634 10.2235 23.5621 10.2115 23.6634 10.2035Z",
    fill: "url(#paint0_linear_301_1727)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5367 12.1688C16.4209 12.6864 16.3638 13.2036 16.3695 13.7053H20.3617C20.3365 13.4987 20.375 13.202 20.4788 12.8698C20.5899 12.5141 20.7769 12.1139 21.0458 11.7335C21.5351 11.0414 22.2969 10.413 23.3672 10.2391C23.2812 10.2368 23.1948 10.2356 23.1082 10.2356H17.2477C16.9231 10.8595 16.6831 11.5141 16.5367 12.1688Z",
    fill: "url(#paint1_linear_301_1727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3666 18.2165 21.3684 18.2165 21.3703 18.2166C21.3924 18.217 21.4144 18.2177 21.4364 18.2185L20.436 13.7339C20.4344 13.7246 20.4329 13.7151 20.4316 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "url(#paint2_linear_301_1727)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 6.08309V10.2035C23.5621 10.2115 23.4634 10.2235 23.3672 10.2391C23.4897 10.2424 23.6115 10.248 23.7327 10.2559V6.08605C23.7096 6.085 23.6865 6.08401 23.6634 6.08309Z",
    fill: "url(#paint3_linear_301_1727)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6012 42.7814V38.6177C8.38898 38.6177 4.16364 34.3924 4.16364 29.1801V19.6732C4.16364 14.7297 7.96443 10.674 12.8032 10.2689C12.8148 10.2683 12.8263 10.2678 12.8379 10.2671C15.2686 10.0169 17.048 8.20034 17.587 6.07197H17.0096H13.8441H13.6012C13.4619 6.07197 13.3231 6.07406 13.1848 6.07822C13.1215 6.08012 13.0583 6.08246 12.9953 6.08523C5.7647 6.40223 4.56865e-08 12.3645 0 19.6732V29.1801L0.00027107 29.2681C0.047588 36.7394 6.11881 42.7814 13.6012 42.7814Z",
    fill: "url(#paint4_linear_301_1727)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7005 10.2702L23.7327 10.2679V10.2559C23.6115 10.248 23.4897 10.2424 23.3672 10.2391C22.2969 10.413 21.5351 11.0414 21.0458 11.7335C20.7769 12.1139 20.5899 12.5141 20.4788 12.8698C20.375 13.202 20.3365 13.4987 20.3617 13.7053H20.4316C20.4252 13.6569 20.4226 13.6024 20.424 13.5426C20.428 13.3646 20.4672 13.1398 20.545 12.8905C20.654 12.5415 20.8379 12.1479 21.1024 11.7737C21.6314 11.0253 22.4815 10.3561 23.7005 10.2702Z",
    fill: "url(#paint5_linear_301_1727)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1082 38.6177V42.7814L23.1961 42.7811C30.6381 42.734 36.662 36.7101 36.7091 29.2681L36.7094 29.1801V19.6732C36.7094 12.3708 30.9546 6.41246 23.7327 6.08605V10.2559C28.6538 10.5775 32.5457 14.6708 32.5457 19.6732V29.1801C32.5457 34.3924 28.3204 38.6177 23.1082 38.6177Z",
    fill: "url(#paint6_linear_301_1727)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 30.6374V35.148C25.5964 35.148 29.0761 31.6683 29.0761 27.3759V21.4774C29.0761 17.185 25.5964 13.7053 21.3039 13.7053H20.5753H20.4316C20.4329 13.7151 20.4344 13.7246 20.436 13.7339L21.4364 18.2185C23.1763 18.2881 24.5654 19.7205 24.5654 21.4774V27.3759C24.5654 29.1772 23.1052 30.6374 21.3039 30.6374Z",
    fill: "url(#paint7_linear_301_1727)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "url(#paint8_linear_301_1727)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 35.148V30.6374H15.4054V35.148H21.3039Z",
    fill: "url(#paint9_linear_301_1727)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1082 42.7814V38.6177H13.6012V42.7814H23.1082Z",
    fill: "url(#paint10_linear_301_1727)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159C19.2446 18.1906 17.8939 17.439 17.1348 16.328C16.6256 15.5828 16.3806 14.6728 16.3695 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165Z",
    fill: "url(#paint11_linear_301_1727)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6012 6.07197H13.8441H17.0096H17.587C18.1268 3.94086 17.4231 1.49712 14.885 0L13.0227 3.435C13.6517 3.71405 14.4228 4.95509 13.2383 6.03098C13.2209 6.04676 13.2031 6.06251 13.1848 6.07822C13.3231 6.07406 13.4619 6.07197 13.6012 6.07197Z",
    fill: "url(#paint12_linear_301_1727)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "url(#paint13_linear_301_1727)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "url(#paint14_linear_301_1727)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 10.2035V6.08309C20.7033 6.09753 18.4221 7.97801 17.2477 10.2356H23.1082C23.1948 10.2356 23.2812 10.2368 23.3672 10.2391C23.4634 10.2235 23.5621 10.2115 23.6634 10.2035Z",
    fill: "url(#paint15_linear_301_1727)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5367 12.1688C16.4209 12.6864 16.3638 13.2036 16.3695 13.7053H20.3617C20.3365 13.4987 20.375 13.202 20.4788 12.8698C20.5899 12.5141 20.7769 12.1139 21.0458 11.7335C21.5351 11.0414 22.2969 10.413 23.3672 10.2391C23.2812 10.2368 23.1948 10.2356 23.1082 10.2356H17.2477C16.9231 10.8595 16.6831 11.5141 16.5367 12.1688Z",
    fill: "url(#paint16_linear_301_1727)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3666 18.2165 21.3684 18.2165 21.3703 18.2166C21.3924 18.217 21.4144 18.2177 21.4364 18.2185L20.436 13.7339C20.4344 13.7246 20.4329 13.7151 20.4316 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "url(#paint17_linear_301_1727)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6634 6.08309V10.2035C23.5621 10.2115 23.4634 10.2235 23.3672 10.2391C23.4897 10.2424 23.6115 10.248 23.7327 10.2559V6.08605C23.7096 6.085 23.6865 6.08401 23.6634 6.08309Z",
    fill: "url(#paint18_linear_301_1727)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7005 10.2702L23.7327 10.2679V10.2559C23.6115 10.248 23.4897 10.2424 23.3672 10.2391C22.2969 10.413 21.5351 11.0414 21.0458 11.7335C20.7769 12.1139 20.5899 12.5141 20.4788 12.8698C20.375 13.202 20.3365 13.4987 20.3617 13.7053H20.4316C20.4252 13.6569 20.4226 13.6024 20.424 13.5426C20.428 13.3646 20.4672 13.1398 20.545 12.8905C20.654 12.5415 20.8379 12.1479 21.1024 11.7737C21.6314 11.0253 22.4815 10.3561 23.7005 10.2702Z",
    fill: "url(#paint19_linear_301_1727)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 30.6374V35.148C25.5964 35.148 29.0761 31.6683 29.0761 27.3759V21.4774C29.0761 17.185 25.5964 13.7053 21.3039 13.7053H20.5753H20.4316C20.4329 13.7151 20.4344 13.7246 20.436 13.7339L21.4364 18.2185C23.1763 18.2881 24.5654 19.7205 24.5654 21.4774V27.3759C24.5654 29.1772 23.1052 30.6374 21.3039 30.6374Z",
    fill: "url(#paint20_linear_301_1727)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "url(#paint21_linear_301_1727)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3039 35.148V30.6374H15.4054V35.148H21.3039Z",
    fill: "url(#paint22_linear_301_1727)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159C19.2446 18.1906 17.8939 17.439 17.1348 16.328C16.6256 15.5828 16.3806 14.6728 16.3695 13.7053H20.3617C20.3634 13.7193 20.3654 13.7328 20.3677 13.746L20.3678 13.7468L20.368 13.7475L21.3647 18.2165Z",
    fill: "url(#paint23_linear_301_1727)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "url(#paint24_linear_301_1727)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "url(#paint25_linear_301_1727)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4054 35.148V30.6374C13.6042 30.6374 12.1439 29.1772 12.1439 27.3759V21.4774C12.1439 19.6761 13.6042 18.2159 15.4054 18.2159H16.9321C15.4054 17.3485 14.6053 15.5789 14.6053 13.746C10.6888 14.1465 7.63333 17.4552 7.63333 21.4774V27.3759C7.63333 31.6348 11.0589 35.0936 15.305 35.1474L15.4054 35.148Z",
    fill: "#F1D506"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1848 6.07822C13.2031 6.06251 13.2209 6.04676 13.2383 6.03098C13.1964 6.06622 13.0993 6.08007 12.9953 6.08523C13.0583 6.08246 13.1215 6.08012 13.1848 6.07822Z",
    fill: "#F1D506"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4316 13.7053H20.5753C20.4712 13.7053 20.4253 13.6359 20.424 13.5426C20.4226 13.6024 20.4252 13.6569 20.4316 13.7053Z",
    fill: "#F1D506"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3003 18.2159C21.3217 18.2162 21.3431 18.2164 21.3647 18.2165C21.3445 18.2161 21.3242 18.2159 21.3039 18.2159H21.3003Z",
    fill: "#F1D506"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3647 18.2165C21.3431 18.2164 21.3217 18.2162 21.3003 18.2159H21.3039C21.3242 18.2159 21.3445 18.2161 21.3647 18.2165Z",
    fill: "#F1D506"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8965 34.9299C52.6867 34.9299 50.7086 34.4131 48.9621 33.3795C47.2275 32.3459 45.8613 30.837 44.8633 28.853C43.8653 26.857 43.3663 24.4215 43.3663 21.5464C43.3663 18.8257 43.8534 16.4674 44.8276 14.4715C45.8019 12.4637 47.1622 10.9132 48.9086 9.82021C50.6551 8.71532 52.6807 8.16287 54.9856 8.16287C56.6845 8.16287 58.2468 8.49552 59.6725 9.16084C61.11 9.82615 62.2684 10.8122 63.1476 12.1191C64.0386 13.4141 64.5138 15.018 64.5732 16.9308H61.1694C61.0982 15.6595 60.7655 14.6081 60.1715 13.7765C59.5893 12.9329 58.8349 12.3033 57.9082 11.8874C56.9815 11.4597 55.9598 11.2459 54.843 11.2459C53.3104 11.2459 51.9323 11.6558 50.7086 12.4755C49.4967 13.2834 48.5403 14.4537 47.8394 15.9863C47.1384 17.5189 46.7879 19.3663 46.7879 21.5286C46.7879 23.9879 47.1562 25.9779 47.8928 27.4986C48.6294 29.0074 49.6155 30.1123 50.8511 30.8133C52.0867 31.5023 53.453 31.8469 54.9499 31.8469C56.3162 31.8469 57.4449 31.6033 58.3359 31.1162C59.2388 30.6172 59.9279 29.9638 60.4031 29.1559C60.8784 28.348 61.1457 27.4748 61.2051 26.5362H64.5732C64.4663 28.2589 64.0089 29.75 63.201 31.0093C62.405 32.2686 61.3061 33.2369 59.9042 33.9141C58.5022 34.5913 56.833 34.9299 54.8965 34.9299ZM68.6829 34.5557V15.113H71.4986L71.855 22.58L71.463 21.5642C71.5461 20.8276 71.7065 20.0613 71.9441 19.2653C72.1936 18.4693 72.5441 17.7268 72.9956 17.0377C73.4589 16.3367 74.047 15.7724 74.7598 15.3447C75.4846 14.917 76.3697 14.7031 77.4152 14.7031C77.6171 14.7031 77.8072 14.715 77.9854 14.7388C78.1755 14.7626 78.3597 14.7923 78.5379 14.8279V18.3386C78.2409 18.2436 77.926 18.1842 77.5934 18.1604C77.2726 18.1248 76.9696 18.1069 76.6845 18.1069C76.1024 18.1069 75.5143 18.2198 74.9202 18.4455C74.3262 18.6713 73.7738 19.0336 73.2629 19.5326C72.752 20.0197 72.3303 20.6553 71.9976 21.4395V34.5557H68.6829ZM89.4791 34.823C87.7089 34.823 86.1525 34.4369 84.81 33.6646C83.4794 32.8924 82.4458 31.7578 81.7092 30.2608C80.9726 28.752 80.6043 26.9105 80.6043 24.7363C80.6043 22.6453 80.9845 20.8514 81.7448 19.3544C82.5052 17.8575 83.5507 16.711 84.8813 15.915C86.2119 15.119 87.7267 14.721 89.4256 14.721C91.1127 14.721 92.5562 15.0833 93.7561 15.808C94.9679 16.5328 95.9006 17.5723 96.554 18.9267C97.2074 20.2692 97.5282 21.879 97.5163 23.7562C97.5163 24.1364 97.5045 24.4512 97.4807 24.7007C97.4569 24.9502 97.4391 25.2116 97.4272 25.4848H83.919C84.0021 27.6233 84.5368 29.245 85.5229 30.3499C86.5208 31.4429 87.7921 31.9895 89.3365 31.9895C90.6434 31.9895 91.6533 31.7162 92.3661 31.1697C93.0908 30.6113 93.5482 29.8985 93.7383 29.0312H96.9817C96.8985 30.2668 96.5184 31.3182 95.8412 32.1855C95.1759 33.0528 94.2967 33.7121 93.2037 34.1636C92.1107 34.6032 90.8691 34.823 89.4791 34.823ZM85.6832 22.9899H94.1838C94.1601 21.3266 93.7502 20.0197 92.9542 19.0693C92.1582 18.1188 90.9404 17.6436 89.3009 17.6436C87.5782 17.6436 86.2713 18.2317 85.3803 19.4079C84.4892 20.5722 84.0021 22.182 83.919 24.2373C84.014 23.7502 84.2041 23.4235 84.4892 23.2572C84.7863 23.079 85.1843 22.9899 85.6832 22.9899ZM108.285 34.7695C106.705 34.7695 105.339 34.3537 104.186 33.5221C103.046 32.6904 102.167 31.5202 101.549 30.0113C100.943 28.5025 100.64 26.7382 100.64 24.7185C100.64 22.485 101.014 20.6316 101.763 19.1584C102.523 17.6733 103.497 16.5684 104.685 15.8437C105.885 15.1071 107.151 14.7388 108.481 14.7388C109.776 14.7388 110.792 14.9586 111.529 15.3982C112.277 15.8377 112.824 16.3486 113.168 16.9308C113.525 17.501 113.738 17.9941 113.81 18.4099L114.861 18.5881L113.578 19.7108C113.495 19.4613 113.293 19.1762 112.972 18.8554C112.651 18.5228 112.194 18.2376 111.6 18C111.006 17.7505 110.251 17.6258 109.337 17.6258C107.804 17.6258 106.539 18.202 105.541 19.3544C104.543 20.495 104.044 22.3067 104.044 24.7898C104.044 27.0946 104.513 28.8648 105.452 30.1004C106.402 31.336 107.62 31.9538 109.105 31.9538C110.032 31.9538 110.798 31.7934 111.404 31.4726C112.022 31.1519 112.503 30.7598 112.847 30.2965C113.204 29.8331 113.447 29.3995 113.578 28.9955L113.756 29.6371L113.578 30.2965C113.519 30.6885 113.388 31.14 113.186 31.6509C112.984 32.1498 112.681 32.6369 112.277 33.1122C111.873 33.5874 111.344 33.9854 110.691 34.3062C110.049 34.6151 109.248 34.7695 108.285 34.7695ZM113.596 34.5557L113.578 6.8263H116.875L116.893 34.5557H113.596ZM122.936 34.5557V15.22H126.286L126.233 34.5557H122.936ZM124.629 12.1013C123.976 12.1013 123.417 11.8756 122.954 11.4241C122.502 10.9726 122.277 10.3905 122.277 9.67765C122.277 8.97669 122.502 8.40048 122.954 7.94902C123.417 7.49755 123.976 7.27182 124.629 7.27182C125.27 7.27182 125.817 7.49755 126.268 7.94902C126.732 8.40048 126.963 8.97669 126.963 9.67765C126.963 10.3905 126.732 10.9726 126.268 11.4241C125.805 11.8756 125.259 12.1013 124.629 12.1013ZM137.647 34.823C136.138 34.823 134.986 34.4369 134.19 33.6646C133.405 32.8805 133.013 31.7697 133.013 30.3321V19.7821C133.013 19.4019 133.091 19.0515 133.245 18.7307C133.4 18.398 133.625 18.1842 133.922 18.0891L133.013 15.8793V15.2734L133.815 9.46379H136.292V29.7797C136.292 30.54 136.471 31.0568 136.827 31.3301C137.183 31.5914 137.795 31.7221 138.663 31.7221C139.292 31.7221 139.827 31.7221 140.267 31.7221C140.706 31.7103 141.164 31.6865 141.639 31.6509V34.5735C140.985 34.6923 140.308 34.7636 139.607 34.7873C138.918 34.8111 138.265 34.823 137.647 34.823ZM130.18 18.0891V15.113H141.478V18.0891H130.18ZM157.442 35.0903C156.028 35.0903 154.745 34.8408 153.592 34.3418C152.44 33.8309 151.519 33.0231 150.83 31.9182C150.141 30.8014 149.773 29.3341 149.725 27.5164H152.933C152.945 28.9302 153.331 30.0351 154.091 30.8311C154.864 31.6152 155.986 32.0073 157.46 32.0073C158.362 32.0073 159.117 31.8528 159.723 31.5439C160.341 31.235 160.804 30.6945 161.113 29.9222C161.434 29.15 161.594 28.0748 161.594 26.6966V8.64403H165.016V26.3402C165.016 28.4074 164.719 30.0826 164.125 31.3657C163.531 32.6488 162.669 33.5933 161.541 34.1992C160.412 34.7933 159.046 35.0903 157.442 35.0903ZM175.059 34.7695C173.824 34.7695 172.754 34.5378 171.851 34.0745C170.96 33.5993 170.271 32.9577 169.784 32.1498C169.309 31.342 169.071 30.4271 169.071 29.4054C169.071 28.348 169.279 27.457 169.695 26.7323C170.111 25.9957 170.711 25.3957 171.495 24.9324C172.279 24.4571 173.229 24.1007 174.346 23.8631C175.083 23.6968 175.861 23.5661 176.681 23.471C177.512 23.376 178.308 23.2988 179.069 23.2394C179.829 23.18 180.477 23.1384 181.011 23.1146V22.0276C181.011 20.4712 180.685 19.3544 180.031 18.6772C179.378 17.9881 178.362 17.6436 176.984 17.6436C176.128 17.6436 175.374 17.7565 174.721 17.9822C174.079 18.2079 173.58 18.6297 173.224 19.2475C172.867 19.8534 172.695 20.7444 172.707 21.9206H169.606C169.463 20.3167 169.689 18.9861 170.283 17.9287C170.877 16.8595 171.768 16.0635 172.956 15.5407C174.144 15.0061 175.552 14.7388 177.18 14.7388C178.106 14.7388 178.992 14.8517 179.835 15.0774C180.679 15.2912 181.427 15.6595 182.081 16.1823C182.734 16.6932 183.251 17.3941 183.631 18.2852C184.011 19.1762 184.201 20.293 184.201 21.6355V34.5557H180.976L181.011 30.3321C180.714 31.6746 180.043 32.7498 178.998 33.5577C177.964 34.3656 176.651 34.7695 175.059 34.7695ZM175.825 32.1498C176.693 32.1498 177.489 31.9895 178.213 31.6687C178.95 31.3479 179.568 30.938 180.067 30.439C180.566 29.94 180.881 29.4292 181.011 28.9064V25.1284C180.322 25.1759 179.556 25.2591 178.712 25.3779C177.869 25.4848 177.126 25.6155 176.485 25.7699C175.202 26.067 174.245 26.465 173.616 26.9639C172.998 27.4629 172.689 28.1817 172.689 29.1203C172.689 29.6787 172.808 30.1895 173.045 30.6529C173.295 31.1043 173.651 31.4667 174.115 31.74C174.578 32.0013 175.148 32.138 175.825 32.1498ZM189.81 34.5557V15.113H192.625L192.982 22.58L192.59 21.5642C192.673 20.8276 192.833 20.0613 193.071 19.2653C193.32 18.4693 193.671 17.7268 194.122 17.0377C194.586 16.3367 195.174 15.7724 195.886 15.3447C196.611 14.917 197.496 14.7031 198.542 14.7031C198.744 14.7031 198.934 14.715 199.112 14.7388C199.302 14.7626 199.486 14.7923 199.665 14.8279V18.3386C199.367 18.2436 199.053 18.1842 198.72 18.1604C198.399 18.1248 198.096 18.1069 197.811 18.1069C197.229 18.1069 196.641 18.2198 196.047 18.4455C195.453 18.6713 194.9 19.0336 194.39 19.5326C193.879 20.0197 193.457 20.6553 193.124 21.4395V34.5557H189.81Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_301_1727",
    x1: 13.1848,
    y1: 13.3236,
    x2: 86.1179,
    y2: 27.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218149,
    stopColor: "#75B467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_301_1727",
    x1: 47.9859,
    y1: -36.5012,
    x2: 12.3868,
    y2: 24.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32875,
    stopColor: "#30A19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733617,
    stopColor: "#56AB7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980445,
    stopColor: "#F1D506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditjarFaviconLight);
export default __webpack_public_path__ + "static/media/creditjarFaviconLight.9a73c5d38cc0b11e78991c03c5660203.svg";
export { ForwardRef as ReactComponent };